import { render, staticRenderFns } from "./LocationNotAllowed.vue?vue&type=template&id=619a1c09"
import script from "./LocationNotAllowed.vue?vue&type=script&lang=js"
export * from "./LocationNotAllowed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports